import { FormControlLabel, Radio } from '@mui/material';

export function Choice(props) {
  const { disabled, option, isSelected, onSelect } = props;
  const unselectedStyle = {
    background: '#eaeaea',
    boxShadow: `0px 1px 5px 0px rgba(0, 0, 0, 0.20), 0px 3px 4px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14);`,
  };

  const selectedStyle = {
    background: '#dedede',
    boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset, 2px 0px 4px 0px rgba(0, 0, 0, 0.25) inset;`,
    '& .MuiSvgIcon-root': { fill: '#629749' },
  };

  return (
    <li>
      <FormControlLabel
        disabled={disabled}
        checked={isSelected}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onSelect(e.target.value)}
        control={<Radio />}
        label={option.label}
        value={option.value}
        sx={{
          height: props.small ? 34 : 52,
          margin: 0,
          width: '100%',
          borderRadius: 2,
          ...(isSelected ? selectedStyle : unselectedStyle),

          '& .MuiRadio-root': {
            px: 1.75,
          },
        }}
      />
    </li>
  );
}
